import * as ngCore from '@angular/core'

import * as state from '../../../../../state'

import * as content from './content'
import * as header from './header'
@ngCore.Component({
  imports: [header.Component, content.Component],
  selector: 'atn-app-page',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)
}
